import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSuperVisorApi,
  deleteSuperVisorApi,
  getSuperVisorByIdApi,
  searchSuperVisorsApi,
  updateSuperVisorApi,
  switchActivationApi,
} from "../apis/superVisorApi";
import { superVisorInitialValues } from "../../modules/superVisor/others/superVisorInitialValues";

export const useCreateSuperVisor = (options = {}) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["create_superVisor"],
    mutationFn: async (data) => {
      return await createSuperVisorApi(data);
    },
    onSuccess() {
      qClient.invalidateQueries(["search_superVisors"]);
    },
  });
};

export const useSearchSuperVisors = (
  body = {},
  params = { page: 0, pageSize: 5 }
) => {
  const bodyHash = JSON.stringify(body);
  return useQuery({
    queryKey: ["search_superVisors", bodyHash, params.page, params.pageSize],
    queryFn: () => searchSuperVisorsApi(body, params),
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
  });
};

export const useUpdateSuperVisor = (superVisorId) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["update_superVisor"],
    mutationFn: async (payload) => {
      return updateSuperVisorApi(superVisorId, payload);
    },
    onSuccess() {
      qClient.invalidateQueries(["search_superVisors"]);
    },
  });
};

export const useSuperVisorById = (superVisorId) => {
  return useQuery({
    queryKey: ["superVisor_info"],
    queryFn: () => getSuperVisorByIdApi(superVisorId),
    initialData: {...superVisorInitialValues},
    retry: 1,
    enabled: !!superVisorId
  });
};

export const useDeleteSuperVisor = (onSuccess) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["delete_superVisor"],
    mutationFn: async (superVisorId) => {
      return deleteSuperVisorApi(superVisorId);
    },
    onSuccess() {
      qClient.invalidateQueries(["search_superVisors"]);
    },
  });
};

export const useSwitchActivationSuperVisor = (onSuccess) => {
  const qClient = useQueryClient();

  return useMutation({
    mutationKey: ["switch_activation_superVisor"],
    mutationFn: async (superVisorId) => {
      return switchActivationApi(superVisorId);
    },
    onSuccess() {
      qClient.invalidateQueries(["search_superVisors"]);
    },
  });
};
